import { render, staticRenderFns } from "./Resellers.vue?vue&type=template&id=50cc6378"
import script from "./Resellers.vue?vue&type=script&lang=js"
export * from "./Resellers.vue?vue&type=script&lang=js"
import style0 from "./Resellers.vue?vue&type=style&index=0&id=50cc6378&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports